import React from 'react';
import { Breadcrumb, Layout, Row, Col } from 'antd';
import { Link, useLocation } from 'react-router-dom';
import CartOptions from './CartOptions';
import InnerHeader from '../../../component/InnerHeader';
import Cart from '../Cart';
import ArrowNextIcon from '../../../asset/arrow-next.svg';

const PaymentCart = () => {
  const location = useLocation();

  function itemRender(route) {
    const mainRoute = route.path === location.pathname;
    return mainRoute ? (
      <b>{route.breadcrumbName}</b>
    ) : (
      <Link to={route.path}>{route.breadcrumbName}</Link>
    );
  }

  const routes = [
    {
      breadcrumbName: 'Cart',
      path: '/cart'
    },
    {
      breadcrumbName: 'Payment Method',
      path: '/cart/payment-method'
    },
    {
      breadcrumbName: 'Overview',
      path: '/cart/payment-method/overview'
    }
  ];

  return (
    <Layout style={{ backgroundColor: 'white', display: 'flex' }}>
      <Row>
        <Breadcrumb
          itemRender={itemRender}
          routes={routes}
          separator={<img alt="separator icon" src={ArrowNextIcon} />}
          style={{
            background: 'white',
            display: 'flex',
            fontSize: '12px',
            justifyContent: 'flex-start',
            padding: '40px 0px 34px 35px'
          }}
        />
      </Row>
      <Row>
        <InnerHeader subtitle="" title="Review Your Cart" />
      </Row>

      <Row>
        <Col>
          <CartOptions />
        </Col>

        <Col>
          <Cart />
        </Col>
      </Row>
    </Layout>
  );
};

export default PaymentCart;
